import { fetchQuery, FetchQueryFetchPolicy } from "relay-runtime"
import { useCareProviderWithOriginQuery } from "@/modules/care-provider/services/__generated__/useCareProviderWithOriginQuery.graphql"
import { careProviderWithOriginQuery } from "@/modules/care-provider/services/useCareProviderWithOrigin"
import { RelayEnvironment } from "@/relay-environment"

const fetchCareProviderWithOrigin = (
  input: useCareProviderWithOriginQuery["variables"],
  next?: (data: useCareProviderWithOriginQuery["response"]) => void,
  cacheConfig?: { fetchPolicy?: FetchQueryFetchPolicy },
) => {
  fetchQuery<useCareProviderWithOriginQuery>(
    RelayEnvironment,
    careProviderWithOriginQuery,
    input,
    cacheConfig,
  ).subscribe({ next })
}

export { fetchCareProviderWithOrigin }
